import styled, { css } from 'styled-components';

const SearchbarLabel = styled.div`
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
  width: 65%;

  ${'' /* border-radius: 10px; */}
  ${'' /* border: 1px solid ${({ theme }) => theme.colors.inactiveIcon}; */}
  ${'' /* padding: 7px 25px; */}
  margin-bottom: 30px;

  ${'' /* background-color: ${({ theme }) => theme.colors.white}; */}
  ${'' /* @media (max-width: 767px) {
    padding: 7px 15px;
  } */}

  .reusecore__input {
    border-radius: 10px;
    input {
      border-radius: 10px;
      font-size: 14px;
      padding: 8px;
      transition: all 0.2s ease;
      &:focus {
        box-shadow: ${({ theme }) => theme.colors.baseBoxShadow};
      }
    }
    .input-icon {
      height: 100% !important;
    }
  }
  ${props =>
    props.isOpen &&
    css`
      ${'' /* box-shadow: ${({ theme }) => theme.colors.baseBoxShadow}; */}
      width: 100%;
      .reusecore__input {
        input {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          box-shadow: none;
        }
      }
    `};
`;

export const DropDown = styled.div`
  position: absolute;
  width: 100%;
  z-index: 2;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  box-shadow: ${({ theme }) => theme.colors.baseBoxShadow};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .search_item:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 10px;
    border-bottom: 0;
  }
`;

export const DropDownItem = styled.div`
  font-size: 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  ${'' /* background: ${props => (props.highlighted ? '#f7f7f7' : 'white')}; */}
  background: ${({ theme }) => theme.colors.white};
  padding: 0.25rem;
  transition: all 0.2s;
  ${'' /* ${props => (props.highlighted ? 'padding-left: 1rem;' : null)}; */}
  display: flex;
  align-items: center;
  ${
    '' /* border-left: 5px solid ${props => (props.highlighted ? props.theme.colors.primary : 'white')}; */
  }
  img {
    margin-right: 10px;
  }
  ${props =>
    props.highlighted &&
    css`
      cursor: pointer;
      font-weight: 500;
      background: #f7f7f7;
      padding-left: 0.5rem;
      border-left: 5px solid ${({ theme }) => theme.colors.primary};
    `};
  ${props =>
    props.fallback &&
    css`
      padding: 1rem;
      text-align: center;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom: 0;
    `};
`;

export default SearchbarLabel;
